/* MARAYA: render the sections returned by the cart mutation, without a second fetch. */
(function () {
  'use strict';
  if (window.MarayaCart) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function sections() {
    var names = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: names } }));
    if (document.getElementById('MinimogCartDrawer')) names.push('cart-drawer');
    if (document.getElementById('MinimogCart')) names.push('cart-template');
    names.push('cart-count');
    return Array.from(new Set(names)).slice(0, 5);
  }
  async function request(path, body) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    var options = { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } };
    if (body) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    try {
      var response = await fetch(root + path, options);
      var data = await response.json();
      if (!response.ok || data.status >= 400 || data.errors) {
        var failure = new Error(typeof data.description === 'string' ? data.description : 'This cart change could not be completed.');
        failure.confirmed = true;
        throw failure;
      }
      return data;
    } catch (error) {
      if (body && !error.confirmed) {
        error.review = true;
        error.message = 'Connection interrupted. Please check your cart before trying again.';
      }
      throw error;
    } finally { clearTimeout(timer); }
  }
  function render(payload, open) {
    var fragments = payload && (payload.sections || payload);
    if (!fragments) return false;
    var pairs = [];
    var groups = { 'cart-drawer': ['MinimogCartDrawerHeader', 'MinimogCartDrawerBody', 'MinimogCartDrawerFooter'], 'cart-template': ['MinimogCartHeader', 'MinimogCartBody', 'MinimogCartFooter'] };
    var complete = true;
    Object.keys(groups).forEach(function (name) {
      var targets = groups[name].filter(function (id) { return document.getElementById(id); });
      if (!targets.length) return;
      if (typeof fragments[name] !== 'string') { complete = false; return; }
      var doc = new DOMParser().parseFromString(fragments[name], 'text/html');
      targets.forEach(function (id) {
        var fresh = doc.getElementById(id);
        if (!fresh) complete = false;
        else pairs.push([document.getElementById(id), fresh]);
      });
    });
    if (!complete || !pairs.length) return false;
    pairs.forEach(function (pair) { pair[0].innerHTML = pair[1].innerHTML; });
    if (typeof fragments['cart-count'] === 'string') {
      var countDoc = new DOMParser().parseFromString(fragments['cart-count'], 'text/html');
      document.querySelectorAll('m-cart-count').forEach(function (node) { if (typeof node.onUpdate === 'function') node.onUpdate(countDoc); });
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: payload } }));
    if (open) {
      var drawer = document.getElementById('MinimogCartDrawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }
    return true;
  }
  async function refresh(payload, open) {
    if (render(payload, open)) return;
    var fresh = await request('?sections=' + sections().map(encodeURIComponent).join(','));
    if (!render(fresh, open)) throw new Error('Cart display could not refresh. Please review your cart.');
  }
  async function add(items, open) {
    var result = await request('cart/add.js', { items: items, sections: sections(), sections_url: window.location.pathname });
    if (!document.getElementById('MinimogCartDrawer') && !document.getElementById('MinimogCart')) {
      window.location.href = root + 'cart';
      return result;
    }
    try { await refresh(result, open !== false); }
    catch (error) { error.review = true; throw error; }
    return result;
  }
  window.MarayaCart = { root: root, sections: sections, request: request, render: render, refresh: refresh, add: add };
})();
